import Job from '@/fstore/collections/Job'
import User from '@/fstore/collections/User'


/**
 * FetchAll takes an object with one of the following properties
 * - UserId: returns all jobs for a candidate.
 * - CompanyId: returns all jobs for a company across all jobs.
 * - JobId:  returns all jobs for a job. This includes ones responded to, declined, expired, etc...
 * 
 * If more than one property is provided, the priority goes:
 * - UserId
 * - CompanyId
 * - JobId
 */
// const fetchAll = async ({commit, dispatch, rootState}) => {
//     const context = {commit, dispatch, rootState};
//     setTimeout(() => {
//         delayedFetch(context);
//     }, 2000)
// }

const fetchAll = async ({commit, dispatch}, {companyId}) => {
   try{
    //dispatch('app/setOverlay', true, { root: true });
    
    let jobs = [];

    // verify we have data. if none of the properties exist, just exit the routine
    if(!companyId){
        console.log("Company Id not provided for Jobs/FetchAll");
        dispatch('app/setOverlay', false, { root: true });
        return jobs;
    }

    // something valid is in here, let's check it out
    jobs = await _fetchAllByCompanyId(companyId)

    commit('setData', jobs);
    
    //dispatch('app/setOverlay', false, { root: true });
   }catch(err) {
    //dispatch('app/setOverlay', false, { root: true });
    console.error(err)
   }
}

// private helpers for fetch all

const _fetchAllByUserId = async (userId) => {
    const jobs = await Job.getAllByUser(userId);
    return jobs;
}

const _fetchAllByCompanyId = async companyId => {
    const jobs = await Job.getAllByCompany(companyId);

    // for (const job of jobs) {
    //     const user = await User.getUserNameFromReference(job.user)
    //     const {numCandidates, numScreenings, numResumes} = await User.getCandidatesForJob(job)

    //     job.user = user
    //     job.numCandidates = numCandidates;
    //     job.numScreenings = numScreenings;
    //     job.numResumes = numResumes;
    // }

    return jobs;
}

const update = async ({state}) => {
    dispatch('app/setOverlay', true, { root: true });
    await Job.update(state);

    dispatch('app/setOverlay', false, { root: true });
}


const reset = ({ commit }) => {
    commit('setData', {});
  }

export default {
    fetchAll,
    reset
}